/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_Limit_RepsInputs */

const en_us2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`none left`)
};

const pt_br2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`não dava +1`)
};

const es_419_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no quedaba ninguna`)
};

const pt_pt2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`não dava +1`)
};

const fr_fr2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aucune en réserve`)
};

const de_de2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine übrig`)
};

const it_it2_workout_quick_effort_limit_reps = /** @type {(inputs: Workout_Quick_Effort_Limit_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nessuna in riserva`)
};

/**
* | output |
* | --- |
* | "none left" |
*
* @param {Workout_Quick_Effort_Limit_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_limit_reps = /** @type {((inputs?: Workout_Quick_Effort_Limit_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_Limit_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_limit_reps(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_limit_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_limit_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_limit_reps(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_limit_reps(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_limit_reps(inputs)
	return en_us2_workout_quick_effort_limit_reps(inputs)
});
export { workout_quick_effort_limit_reps as "workout-quick.effort_limit_reps" }